import React, { useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import "../../Pages/Admin/Style.css";
import "./add_customer.css";
import { addUser } from "../../Api/apiUrls";

function Add_venueowner({ onClose }) {
  const [modalAdd_venueownerIsOpen, setAdd_venueownerModalIsOpen] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [image, setImage] = useState(null);
  const [isAddingcustomer, setIsAddingcustomer] = useState(false);

  const closeAdd_venueowner = () => {
    setAdd_venueownerModalIsOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsAddingcustomer(true);

    // Basic validation
    if (!name.trim() || !email.trim() || !mobile.trim()) {
      alert("Please fill in all required fields");
      setIsAddingcustomer(false);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      alert("Please enter a valid email address");
      setIsAddingcustomer(false);
      return;
    }

    const mobileRegex = /^\d{10}$/;
    if (!mobileRegex.test(mobile.trim())) {
      alert("Please enter a valid 10-digit mobile number");
      setIsAddingcustomer(false);
      return;
    }

    const formData = new FormData();
    formData.append("name", name.trim());
    formData.append("email", email.trim());
    formData.append("mobileNumber", mobile.trim());
    formData.append("type_of_user", "Venue Owner");
    if (image) {
      formData.append("profile_image", image);
    }

    try {
      const response = await fetch(addUser, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      alert(data.message);
      onClose();
      window.location.reload();
    } catch (error) {
      console.error("Error adding customer:", error);
      alert(`Error: ${error.message}`);
    } finally {
      setIsAddingcustomer(false);
    }
  };

  return (
    <div>
      {modalAdd_venueownerIsOpen && <add_customer onClose={closeAdd_venueowner} />}
      <div className="popup-background">
        <div className="popup">
          <div
            className="modal-content"
            style={{
              width: "100%",
              height: "auto",
              padding: "2%",
              backgroundColor: "#fff",
              borderRadius: "5px",
            }}
          >
            <div
              className="modal-header"
              style={{
                width: "100%",
                marginBottom: "3%",
                borderBottom: "solid 1px #7e7a7a8c",
              }}
            >
              <h5
                className="modal-title"
                id="modalAddTitle"
                style={{ marginBottom: "2%" }}
              >
                <b>Add Venue Owner</b>
              </h5>
            </div>

            <div className="modal-body" style={{ overflowY: "none", padding: "2%" }}>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="small mb-1" htmlFor="inputName">
                    Name<font color="red">*</font>
                  </label>
                  <input
                    className="form-control"
                    id="inputName"
                    type="text"
                    placeholder="Enter Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="small mb-1" htmlFor="inputEmail">
                    Email<font color="red">*</font>
                  </label>
                  <input
                    className="form-control"
                    id="inputEmail"
                    type="email"
                    placeholder="Enter Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="small mb-1" htmlFor="inputMobile">
                    Mobile Number<font color="red">*</font>
                  </label>
                  <input
                    className="form-control"
                    id="inputMobile"
                    type="tel"
                    placeholder="Enter Mobile Number"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="small mb-1" htmlFor="inputImage">
                    Profile Image
                  </label>
                  <input
                    className="form-control"
                    id="inputImage"
                    type="file"
                    accept="image/*"
                    onChange={(e) => setImage(e.target.files[0])}
                  />
                </div>

                <div
                  className="modal-footer"
                  style={{
                    padding: "2%",
                    marginTop: "3%",
                    borderTop: "solid 1px #7e7a7a8c",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      onClose();
                    }}
                  >
                    Close
                  </button>
                  {isAddingcustomer ? (
                    <div>
                      <ThreeDots color="#000" height={50} width={50} />
                    </div>
                  ) : (
                    <button
                      id="btnAdd"
                      type="submit"
                      className="btn btn-primary"
                      style={{ background: "black", border: "none" }}
                    >
                      Add
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Add_venueowner;
